import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ENVELOPE_STATUS } from "@/utils/constants/constants";
import { getStatusClass } from "@/utils/functions/helperFunctions";

interface StatusBadgeProps {
    envelope: any;
    title?: string | "";
    id?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ envelope, title, id }) => {
    const signedCount = envelope.recipients?.filter((rec: any) => rec.status === "signed").length ?? 0;
    const totalCount = Math.max(envelope.recipients?.length ?? 0, 1);
    const progressPercent = (100 * signedCount) / totalCount;
    const isDetailView = title === "details";

    const tableBadgeClassName = `badge badge-dim badge-sm text-capitalize gs-envelope-table-status-badge ${getStatusClass(envelope.status)}`;
    const detailBadgeClassName = `badge badge-dim badge-sm text-capitalize gs-envelope-detail-status-badge ${getStatusClass(envelope.status)}`;

    if (isDetailView) {
        return (
            <span id={`${id}-status-badge`} className={detailBadgeClassName}>
                {envelope.status}
            </span>
        );
    }

    return (
        <span>
            {envelope.status === ENVELOPE_STATUS.SENT ? (
                <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <div className="gs-envelope-table-status-sent">
                                    <div className="project-list-progress gs-envelope-table-status-progress p-0">
                                        <div className="progress gs-envelope-table-status-progress-bar">
                                            <div
                                                className="progress-bar"
                                                role="progressbar"
                                                style={{ width: `${progressPercent}%` }}
                                                aria-valuenow={progressPercent}
                                                aria-valuemin={0}
                                                aria-valuemax={100}
                                            />
                                        </div>
                                        <div className="text-soft gs-envelope-table-status-progress-label p-0">
                                            {signedCount}/{envelope.recipients?.length ?? 0} done
                                        </div>
                                    </div>
                                    <div className="meta gs-envelope-table-status-sent-label">
                                        <span className="version">
                                            <span className="text-dark" id={`${id}-status-badge`}>
                                                Needs To Sign
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </TooltipTrigger>
                            <TooltipContent side="bottom">
                                <span>
                                    {signedCount}/{envelope.recipients?.length ?? 0}
                                </span>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
            ) : (
                <div className="meta">
                    <span className="version">
                        <span id={`${id}-status-badge`} className={tableBadgeClassName}>
                            {envelope.status}
                        </span>
                    </span>
                </div>
            )}
        </span>
    );
};

export default StatusBadge;
